"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetCait() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="meet-cait" ref={sectionRef} className="relative bg-background py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-secondary/5 pointer-events-none" />
      
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div className={`space-y-4 transition-all duration-[var(--duration-fast)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Meet CAIT
            </h2>
            <p className="text-base sm:text-lg text-foreground leading-relaxed max-w-xl">
               In a world where support communication often feels distant and cold, we believe technology should still feel like a handshake. 
               That's why we developed CAIT—our professional AI interface designed specifically for the pace and culture of local business.  
               CAIT manages your leads, schedules your callbacks, and assists your customers with the poise and hospitality our region is known for. It's the enterprise-grade automation you need
               to scale, delivered with the professional charm of a neighbor who's been in the business for decades.
            </p>
          </div>

          {}
          <div className={`flex justify-center lg:justify-end transition-all duration-[var(--duration-fast)] ease-[var(--ease-out-back)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative group">
              <SafeHydrate><Avatar className="size-64 sm:size-80 lg:size-96 shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-[1.02] group-hover:shadow-strong">
                <AvatarImage src="https://enough-jackass.10web.cloud/wp-content/uploads/2026/01/ChatGPT-Image-Jan-2-2026-12_15_38-AM.png" alt="CAIT - Coastal AI Assistant" className="aspect-square size-full object-cover !m-0 !p-0" />
                <AvatarFallback className="bg-primary text-foreground-primary text-6xl font-display font-bold">
                  CAIT
                </AvatarFallback>
              </Avatar></SafeHydrate>
            </div>
          </div>
        </div>
      </div>
    </section>;
}